// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"8c352438","128":"88d63045","189":"03d1534c","200":"0ad58a5e","216":"2cfa9b0d","228":"9e5a6685","432":"7c094f88","504":"e68e0ac7","592":"8a8b7916","640":"a6620247","672":"43d0ef03","752":"c5224deb","808":"010be5a9"}[chunkId] + ".chunk.js";
};